export default () => ({
  statusAllCourses: "",
  allCourses: [],
  statusAllActivities: "",
  allActivities: [],
  statusToken: "",
  statusBookCourse: "",
  bookCourse: undefined,
  statusCheckAvailability: "",
  statusBookActivity: "",
});
